import payment from './payment-reducer';

export * from './payment-reducer';
export default payment;
